import { ResolverEnum } from '@e-socna/data-layer';

import type { ResolverHook } from '../types/resolver-hook.type';

import { useDateCourante } from '../useDateCourante.resolver';
import { useDateHeureCourante } from '../useDateHeureCourante.resolver';
import { useDevisAcceptationCGV } from '../useDevisAcceptationCGV.resolver';
import { useDevisAvecModalites } from '../useDevisAvecModalites.resolver';
import { useDevisAvecNota } from '../useDevisAvecNota.resolver';
import { useDevisInterlocuteur } from '../useDevisInterlocuteur.resolver';
import { useDevisEmetteur } from '../useDevisEmetteur.resolver';
import { useDevisHonoraires } from '../useDevisHonoraires.resolver';
import { useDevisLieuDate } from '../useDevisLieuDate.resolver';
import { useDevisModalites } from '../useDevisModalites.resolver';
import { useDevisNota } from '../useDevisNota.resolver';
import { useDevisObjet } from '../useDevisObjet.resolver';
import { useDevisPolitesseIntro } from '../useDevisPolitesseIntro.resolver';
import { useDevisPolitesseOutro } from '../useDevisPolitesseOutro.resolver';
import { useDevisPrestations } from '../useDevisPrestations.resolver';
import { useDevisPrestationsTableau } from '../useDevisPrestationsTableau.resolver';
import { useDevisReference } from '../useDevisReference.resolver';
import { useDevisReglement } from '../useDevisReglement.resolver';
import { useDevisSignatureGerant } from '../useDevisSignatureGerant.resolver';
import { useDocIdentifiant } from '../useDocIdentifiant.resolver';
import { useDocIncrementGeneration } from '../useDocIncrementGeneration.resolver';
import { useDocNombreTotalPages } from '../useDocNombreTotalPages.resolver';
import { useDocTableDesMatieres } from '../useDocTableDesMatieres.resolver';
import { useDocTitre } from '../useDocTitre.resolver';
import { useMissionTitre } from '../useMissionTitre.resolver';
import { useSIGCarteLieuMission } from '../useSIGCarteLieuMission.resolver';
import { useSIGDistanceArrondieMissionAgenceEnKmAuPlusCourt } from '../useSIGDistanceArrondieMissionAgenceEnKmAuPlusCourt.resolver';
import { useSIGDistanceArrondieMissionAgenceEnKmAuPlusLong } from '../useSIGDistanceArrondieMissionAgenceEnKmAuPlusLong.resolver';
import { useSIGDistanceArrondieMissionAgenceEnKmAuPlusRapide } from '../useSIGDistanceArrondieMissionAgenceEnKmAuPlusRapide.resolver';
import { useSIGDistanceExacteMissionAgenceEnKmAuPlusCourt } from '../useSIGDistanceExacteMissionAgenceEnKmAuPlusCourt.resolver';
import { useSIGDistanceExacteMissionAgenceEnKmAuPlusLong } from '../useSIGDistanceExacteMissionAgenceEnKmAuPlusLong.resolver';
import { useSIGDistanceExacteMissionAgenceEnKmAuPlusRapide } from '../useSIGDistanceExacteMissionAgenceEnKmAuPlusRapide.resolver';

interface ResolverRegistryEntry {
  readonly resolverEnum: ResolverEnum;
  readonly hook: ResolverHook;
}

export const RESOLVER_REGISTRY: readonly ResolverRegistryEntry[] = [
  { resolverEnum: ResolverEnum.DateCourante, hook: useDateCourante },
  {
    resolverEnum: ResolverEnum.DateHeureCourante,
    hook: useDateHeureCourante,
  },
  {
    resolverEnum: ResolverEnum.DevisAcceptationCgv,
    hook: useDevisAcceptationCGV,
  },
  {
    resolverEnum: ResolverEnum.DevisInterlocuteur,
    hook: useDevisInterlocuteur,
  },
  {
    resolverEnum: ResolverEnum.DevisEmetteur,
    hook: useDevisEmetteur,
  },
  {
    resolverEnum: ResolverEnum.DevisHonoraires,
    hook: useDevisHonoraires,
  },
  {
    resolverEnum: ResolverEnum.DevisLieuDate,
    hook: useDevisLieuDate,
  },
  {
    resolverEnum: ResolverEnum.DevisAvecModalites,
    hook: useDevisAvecModalites,
  },
  { resolverEnum: ResolverEnum.DevisAvecNota, hook: useDevisAvecNota },
  {
    resolverEnum: ResolverEnum.DevisModalites,
    hook: useDevisModalites,
  },
  {
    resolverEnum: ResolverEnum.DevisNota,
    hook: useDevisNota,
  },
  {
    resolverEnum: ResolverEnum.DevisObjet,
    hook: useDevisObjet,
  },
  {
    resolverEnum: ResolverEnum.DevisPolitesseIntro,
    hook: useDevisPolitesseIntro,
  },
  {
    resolverEnum: ResolverEnum.DevisPolitesseOutro,
    hook: useDevisPolitesseOutro,
  },
  {
    resolverEnum: ResolverEnum.DevisPrestations,
    hook: useDevisPrestations,
  },
  {
    resolverEnum: ResolverEnum.DevisPrestationsTableau,
    hook: useDevisPrestationsTableau,
  },
  {
    resolverEnum: ResolverEnum.DevisReference,
    hook: useDevisReference,
  },
  {
    resolverEnum: ResolverEnum.DevisReglement,
    hook: useDevisReglement,
  },
  {
    resolverEnum: ResolverEnum.DevisSignatureGerant,
    hook: useDevisSignatureGerant,
  },
  { resolverEnum: ResolverEnum.DocIdentifiant, hook: useDocIdentifiant },
  {
    resolverEnum: ResolverEnum.DocIncrementGeneration,
    hook: useDocIncrementGeneration,
  },
  {
    resolverEnum: ResolverEnum.DocNombreTotalPages,
    hook: useDocNombreTotalPages,
  },
  {
    resolverEnum: ResolverEnum.DocTableDesMatieres,
    hook: useDocTableDesMatieres,
  },
  { resolverEnum: ResolverEnum.DocTitre, hook: useDocTitre },
  { resolverEnum: ResolverEnum.MissionTitre, hook: useMissionTitre },
  {
    resolverEnum: ResolverEnum.SigCarteLieuMission,
    hook: useSIGCarteLieuMission,
  },
  {
    resolverEnum: ResolverEnum.SigDistanceArrondieMissionAgenceEnKmAuPlusCourt,
    hook: useSIGDistanceArrondieMissionAgenceEnKmAuPlusCourt,
  },
  {
    resolverEnum: ResolverEnum.SigDistanceArrondieMissionAgenceEnKmAuPlusLong,
    hook: useSIGDistanceArrondieMissionAgenceEnKmAuPlusLong,
  },
  {
    resolverEnum: ResolverEnum.SigDistanceArrondieMissionAgenceEnKmAuPlusRapide,
    hook: useSIGDistanceArrondieMissionAgenceEnKmAuPlusRapide,
  },
  {
    resolverEnum: ResolverEnum.SigDistanceExacteMissionAgenceEnKmAuPlusCourt,
    hook: useSIGDistanceExacteMissionAgenceEnKmAuPlusCourt,
  },
  {
    resolverEnum: ResolverEnum.SigDistanceExacteMissionAgenceEnKmAuPlusLong,
    hook: useSIGDistanceExacteMissionAgenceEnKmAuPlusLong,
  },
  {
    resolverEnum: ResolverEnum.SigDistanceExacteMissionAgenceEnKmAuPlusRapide,
    hook: useSIGDistanceExacteMissionAgenceEnKmAuPlusRapide,
  },
] as const;

export const RESOLVER_HOOK_MAP = Object.fromEntries(
  RESOLVER_REGISTRY.map(({ resolverEnum, hook }) => [resolverEnum, hook]),
) as Record<ResolverEnum, ResolverHook>;
